/**
 * This file contains mock handlers for the cart components package.
 * These are temporary solutions until all mocks have been migrated to the mock-schema package.
 */
import { handler as baseAddToCartHandler } from "./mocks/handlers/cart/addToCart.mutation";
export var addToCartHandler = baseAddToCartHandler;